import api from '../../../services/api';
import eventFactory from '../../../factories/event.factory';
import {
  DISPLAYED_MESSAGE_DATA,
  GET_USER_SUGGESTION_SUCCESS,
  GET_USER_SUGGESTION_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
} from './linkUser.mutations';

export const ASSOCIATE_USER = 'ASSOCIATE_USER';
export const GET_USER_SUGGESTION = 'GET_USER_SUGGESTION';
export const CREATE_USER_LINK_WITH_HOSPITAL = 'CREATE_USER_AND_LINK_WITH_HOSPITAL';

export default {
  async [ASSOCIATE_USER]({ commit }, { hospitalId, role, userId, displayName }) {
    const displayMessagePayload = {
      isResponseMessageVisible: true,
      displayName,
    };
    try {
      const response = await api.linkUserWithHospital(hospitalId, userId, role);
      displayMessagePayload.statusCode = response.statusCode;
      commit(DISPLAYED_MESSAGE_DATA, displayMessagePayload);
      document.dispatchEvent(eventFactory.getUserLinkedEvent());
    } catch (e) {
      displayMessagePayload.statusCode = e.response.statusCode;
      displayMessagePayload.message = e.response.body && e.response.body.message;
      commit(DISPLAYED_MESSAGE_DATA, displayMessagePayload);
    }
  },
  async [GET_USER_SUGGESTION]({ commit }, { query }) {
    try {
      const response = await api.getUserSuggestion(query);
      commit(GET_USER_SUGGESTION_SUCCESS, response.body.users);
    } catch (e) {
      commit(GET_USER_SUGGESTION_FAILURE);
    }
  },
  async [CREATE_USER_LINK_WITH_HOSPITAL]({ commit }, { hospitalId, role, email, username, firstName, lastName, sendWelcomeEmail }) {
    const displayName = `${firstName} ${lastName}`;
    const displayMessagePayload = {
      isResponseMessageVisible: true,
      displayName,
    };
    try {
      const createUserResponse = await api.createUser(hospitalId, email, username, firstName, lastName, sendWelcomeEmail, role);
      displayMessagePayload.message = createUserResponse.body.message;
      displayMessagePayload.statusCode = createUserResponse.statusCode;
      commit(CREATE_USER_SUCCESS, displayMessagePayload);
      document.dispatchEvent(eventFactory.getUserLinkedEvent());
    } catch (e) {
      displayMessagePayload.message = e.response.body.message;
      displayMessagePayload.statusCode = e.response.statusCode;
      commit(CREATE_USER_FAILURE, displayMessagePayload);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/linkUser/linkUser.actions.js